<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png"
      />
      <div class="section_1 flex-col">
        <div class="block_3 flex-col">
          <div class="group_3 flex-row">
            <div class="text-group_1 flex-col">
              <span class="text_13">学科与科研</span>
              <span class="text_14">创新工程页面作为“学科与科研”栏目下的独立二级页，集中呈现该项目的总体概述。</span>
            </div>
          </div>
          <div class="text-wrapper_2">
            <span class="text_15">
              <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
              &nbsp;&gt;&nbsp;
              <router-link to="/lanhu_xuekeyukeyan" style="color: inherit; text-decoration: none;">学科与科研</router-link>
              &nbsp;&gt;&nbsp;
            </span>
            <span class="text_16">创新工程</span>
          </div>
          <div class="group_4 flex-col"></div>
          <div class="group_5 flex-row justify-between">
            <div class="sidebar-slot">
              <SidebarAccordion
                :sections="sidebarSections"
                active-section-id="discipline"
                active-item-id="innovation-project"
                active-sub-item-id="innovation-project-detail"
              />
            </div>
            <div class="group_7 flex-col content-slot">
              <div class="text-wrapper_4 flex-col"><span class="text_19">创新工程</span></div>

              <section class="overview-card">
                <div class="overview-card__header">
                  <p class="overview-card__kicker">2013 起</p>
                  <h2 class="overview-card__title">创新工程概述</h2>
                </div>
                <div class="overview-card__body">
                  <p>
                    2013 年起，新闻与传播研究所经中国社会科学院批准实施创新工程项目“变革中的新闻与传播：实践探索与理论构建”。该工程的实施打破了既往的科室分界，实行跨机构人员配置，同时也在人才培养、科研组织方式创新和管理体制机制改革等方面推出新举措、拓展新理念、开辟新路径。
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <SiteFooter
        :notch-width="704"
        notch-left="calc((100vw - 1300px) / 2 + 445px)"
      />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import SidebarAccordion from '@/components/SidebarAccordion.vue';
import { createSidebarSections } from '@/config/secondarySidebar';

export default {
  name: 'LanhuChuangxingongcheng',
  components: {
    SiteHeader,
    SiteFooter,
    SidebarAccordion
  },
  data() {
    return {
      sidebarSections: createSidebarSections({
        activeSectionId: 'discipline',
        activeItemId: 'innovation-project',
        activeSubItemId: 'innovation-project-detail'
      })
    };
  }
};
</script>

<style scoped lang="css" src="../lanhu_jigouyulishi/assets/index.css" />
<style scoped>
.section_1 {
  min-height: auto;
}

.block_3 {
  min-height: auto;
  padding-bottom: 88px;
}

.group_3 {
  padding-bottom: 36px;
}

.text_14 {
  height: auto;
}

.group_5 {
  align-items: flex-start;
}

.sidebar-slot {
  width: 274px;
  flex: 0 0 274px;
}

.sidebar-slot :deep(.sidebar-accordion) {
  width: 100%;
}

.content-slot {
  flex: 1;
  min-width: 0;
}

.overview-card {
  padding: 32px 40px 38px;
  border-radius: 18px;
  border: 1px solid rgba(227, 205, 177, 0.9);
  background:
    radial-gradient(circle at left center, rgba(242, 228, 210, 0.38), rgba(255, 255, 255, 0) 28%),
    radial-gradient(circle at right center, rgba(242, 228, 210, 0.2), rgba(255, 255, 255, 0) 26%),
    linear-gradient(180deg, #fffdfb 0%, #ffffff 100%);
  box-shadow: 0 12px 24px rgba(59, 41, 17, 0.04);
}

.overview-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(227, 205, 177, 0.9);
}

.overview-card__kicker {
  margin: 0;
  color: #bc8a4d;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.overview-card__title {
  margin: 0;
  color: #f25c19;
  font-size: 28px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.overview-card__body {
  padding: 28px 18px 0;
}

.overview-card__body p {
  margin: 0;
  color: #231f20;
  font-size: 15px;
  line-height: 2.2;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

@media (max-width: 1200px) {
  .group_5 {
    flex-direction: column;
    gap: 24px;
  }

  .sidebar-slot {
    width: 100%;
    flex-basis: auto;
  }

  .overview-card {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .overview-card {
    padding: 24px 20px 28px;
  }

  .overview-card__header {
    display: block;
  }

  .overview-card__title {
    margin-top: 6px;
    font-size: 24px;
  }

  .overview-card__body {
    padding: 20px 0 0;
  }
}
</style>
